<template>
  <div class="col-12">
    <div class="app-content">
      <div class="app-title">
        <div>
          <h1>
            <font-awesome-icon icon="tools" />
            Tiện ích
          </h1>
          <p class="text-muted mb-0">
            Bộ công cụ vận hành &amp; hỗ trợ nội bộ. Mỗi thẻ là một tác vụ độc lập — đọc mô tả trước khi chạy.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 mb-4" v-for="tool in visibleTools" :key="tool.key">
          <div class="tile h-100">
            <div class="d-flex align-items-start mb-3 pb-2 c-tool-head">
              <span class="c-tool-icon mr-3"><font-awesome-icon :icon="tool.icon" /></span>
              <div>
                <h6 class="mb-1 font-weight-bold">{{ tool.title }}</h6>
                <small class="text-muted">{{ tool.desc }}</small>
              </div>
            </div>
            <component :is="tool.component" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ToolContact from './Contact';
import FilterEmail from './FilterEmail';
import CallSync from './CallSync';
import ClearCache from './ClearCache';
import IndexSearch from './IndexSearch.vue';
import PlanCalculator from "@/views/tool/PlanCalculator";
import UploadRecording from "@/views/tool/UploadRecording.vue";


export default {
  components: {
    PlanCalculator,
    "tool-contact": ToolContact,
    "filter-email": FilterEmail,
    CallSync,
    ClearCache,
    UploadRecording,
    IndexSearch,
  },
  data() {
    return {
      tools: [
        {
          key: 'call-sync',
          component: 'CallSync',
          icon: 'sync-alt',
          title: 'Đồng bộ lại cuộc gọi',
          desc: 'Nhập ID cuộc gọi để đồng bộ lại lịch sử khách hàng, chiến dịch gọi, lịch sử ticket và cuộc gọi nhỡ.',
          roles: ['admin', 'owner', 'tech', 'account', 'am'],
        },
        {
          key: 'upload-recording',
          component: 'UploadRecording',
          icon: 'cloud-upload-alt',
          title: 'Tải lên ghi âm cuộc gọi',
          desc: 'Bù file ghi âm cho một cuộc gọi theo ID khi bản ghi bị thiếu.',
          roles: ['admin', 'owner', 'tech', 'account', 'am'],
        },
        {
          key: 'contact',
          component: 'tool-contact',
          icon: 'address-card',
          title: 'Đồng bộ liên hệ theo số điện thoại',
          desc: 'Khởi tạo / đồng bộ lại cuộc gọi cho một số điện thoại của domain khi khách hàng mới chưa khớp.',
          roles: ['admin', 'owner', 'tech', 'account', 'am'],
        },
        {
          key: 'filter-email',
          component: 'filter-email',
          icon: 'at',
          title: 'Tra cứu khách hàng theo email',
          desc: 'Tìm thông tin client (công ty, số điện thoại, gói dịch vụ, người dùng…) từ địa chỉ email.',
          roles: ['admin', 'owner', 'tech', 'account', 'am', 'manager'],
        },
        {
          key: 'index-search',
          component: 'IndexSearch',
          icon: 'database',
          title: 'Đánh index tìm kiếm',
          desc: 'Index lại dữ liệu (khách hàng…) có thời gian cập nhật trong 24h gần nhất cho một domain.',
          roles: ['admin', 'owner', 'tech'],
        },
        {
          key: 'plan-calculator',
          component: 'PlanCalculator',
          icon: 'calculator',
          title: 'Máy tính gói dịch vụ',
          desc: 'Dự toán chi phí khi nâng cấp gói, gia hạn gói hoặc mua thêm tài khoản người dùng.',
          roles: ['admin', 'owner', 'tech', 'account', 'am', 'manager'],
        },
        {
          key: 'clear-cache',
          component: 'ClearCache',
          icon: 'broom',
          title: 'Xoá cache hệ thống',
          desc: 'Xoá cache theo key/pattern. Dùng thận trọng — chỉ dành cho chủ tài khoản (owner).',
          roles: ['owner'],
        },
      ],
    };
  },
  computed: {
    visibleTools() {
      const role = this.$store.state.user.role;
      return this.tools.filter(tool => tool.roles.includes(role));
    },
  },
}
</script>
<style scoped>
.c-tool-head {
  border-bottom: 1px solid #ebedf2;
}

.c-tool-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 16px;
}
</style>
